import { validate } from '@balance-web/forms';

export const validatePhoneNumber = (value: string) => {
  if (!new RegExp('^0[0-9]{9}$').test(value))
    return validate.error(
      'Field must only contain 10 numbers, including area code (e.g. 02..., 04...)'
    );
  return value;
};

export const validatePhoneNumberByCountryCode = (
  value: string,
  country: string
) => {
  const AURegex = /^0(4|5)[0-9]{8}$/;
  const NZRegex = /^((021|022|025|027|028|029)\d{6,8})$/;
  const UKRegex = /^07(1|2|3|4|5|6|7|8|9)\d{5,8}$/;
  if (!/^0[0-9]{8,10}$/.test(value))
    return validate.error(
      'Field must only contain mobile numbers with area code (e.g. 02..., 04...)'
    );

  if (
    (country === 'AU' && !AURegex.test(value)) ||
    (country === 'NZ' && !NZRegex.test(value)) ||
    (country === 'GB' && !UKRegex.test(value))
  )
    return validate.error('Invalid Mobile number');
  return value;
};

export const validateEmail = (value: string) => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!pattern.test(value)) {
    return validate.error('Please enter a correct email address');
  }
  return value;
};

export const validateRecoveryPin = (value: string) => {
  if (!/^\d{1,}$/.test(value))
    return validate.error('Recovery pin must be numeric');
  if (!/^\d{6}$/.test(value))
    return validate.error('Recovery pin must be 6-digits');
  else if (
    !/^(?!.*(?:(\d{2})\1{2}))\d{6}$/.test(value) ||
    !/^(?!.*(?:(\d{3})\1))\d{6}$/.test(value)
  )
    return validate.error('Repeated numbering is not allowed');
  else if (
    !/^(?!.*(?:01234|12345|23456|34567|45678|56789|67890|78901|89012|90123)).*$/.test(
      value
    )
  )
    return validate.error('Sequential numbering is not allowed');
  else if (
    !/^(?!.*(?:09876|98765|87654|76543|65432|54321|43210|32109|21098|10987))\d{6}$/.test(
      value
    )
  )
    return validate.error('Sequential numbers are not allowed');
  else return value;
};

export const validatePassword = (value: string) => {
  // password profile:
  // min 8 characters
  // at least 1 upper case alphabet
  // at least 1 lower case alphabet
  // at least 1 number
  // at least 1 of these !@#$%^&*()_-+= special characters

  // eslint-disable-next-line no-useless-escape
  const specialCharMatch = `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#_%&,'";><\`\|\$\^\*\.\?\:\{\}\(\)\/\\]\[\+])(?=.{8,})`;
  const match = `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})`;

  if (!new RegExp(match).test(value))
    return validate.error(
      'Must have minimum 8 characters with an upper case, a lower case, a numeric and a special character.'
    );
  else if (!new RegExp(specialCharMatch).test(value))
    return validate.error(
      'Only ^$*.?"!@#%&,\'`:;|_~><{}[]()+ are allowed special characters'
    );
  else if (value.length > 16)
    return validate.error('Must contain less than 16 characters');
  else if (
    / /.test(value) ||
    /\s/.test(value) ||
    /\t/.test(value) ||
    /\n/.test(value)
  )
    return validate.error(
      'Only ^$*.?"!@#%&,\'`:;|_~><{}[]()+ are allowed special characters'
    );
  else return value;
};
